import { useContext, useEffect } from 'react';

import { ParamsContext } from './ParamsContext';

export default function useParams(type, payload = undefined) {
  const { params, requestParam } = useContext(ParamsContext);
  const { items, isLoading } = params[type];

  useEffect(() => {
    requestParam(type, payload);
  }, [requestParam, type, payload]);

  return [items, isLoading];
}
